import {
  type DiscoveryResponse,
  type LeadDetailApi,
} from '@viq-admin/screens';
import { adminFetch } from '../../api/dataProvider';
import { createRawnote, editLead, editRawnote, fetchLeadDetail } from '../../api/leadEdit';
import {
  updateConferenceResponse,
  deleteConferenceResponse,
} from '../../api/conferenceResponses';

/**
 * Customer-plane wiring for the shared Lead Detail body. The portal's
 * `/v1/admin/*` endpoints return the same raw shapes the shared `mapLeadDetail`
 * + panels expect (the shared code was extracted from this portal), so it
 * renders an exact mirror. Token-scoped — no `?companyId=`.
 */
export const leadDetailApi: LeadDetailApi = {
  // Re-exports the api layer's canonical GET /v1/admin/leads/:id — same
  // function `crmUpload.ts`'s `updateLeadFields` composes over, so the
  // endpoint literal lives in exactly one place (`api/leadEdit.ts`).
  fetchLeadDetail,

  archiveLead: async (id: string): Promise<void> => {
    await adminFetch<void>(`/v1/admin/leads/${id}/archive`, { method: 'POST' });
  },

  restoreLead: async (id: string): Promise<void> => {
    await adminFetch<void>(`/v1/admin/leads/${id}/restore`, { method: 'POST' });
  },

  updateLead: (id, fields, expectedVersion) => editLead(id, fields, expectedVersion),

  fetchDiscovery: (personId: string): Promise<DiscoveryResponse | null> =>
    adminFetch<DiscoveryResponse | null>(`/v1/admin/persons/${personId}/discovery`),

  updateNote: (leadId, noteId, fields, expectedVersion) =>
    editRawnote(leadId, noteId, fields, expectedVersion),

  createNote: (leadId, text) => createRawnote(leadId, text),

  // Keyed by the QUESTION's conferenceId (passed down by DiscoveryPanel), not
  // the lead's. companyId is omitted — the portal's calls are token-scoped.
  updateDiscoveryAnswer: (conferenceId, personId, questionId, body) =>
    updateConferenceResponse(conferenceId, personId, questionId, body),

  deleteDiscoveryAnswer: (conferenceId, personId, questionId) =>
    deleteConferenceResponse(conferenceId, personId, questionId),
};
